import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 7;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'rec-hub',
      title: `Reconciliation Hub <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'This is where you reconcile your bank accounts — matching your records to your bank statement to ensure everything is accurate.',
      attachTo: { element: '[data-tour="rec-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-account-selector',
      title: `Account Selector <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Select which bank account to reconcile. Only accounts set up as register accounts appear here.',
      attachTo: { element: '[data-tour="rec-account-selector"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-history',
      title: `Past Reconciliations <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'View your completed reconciliations. You can export any past reconciliation as a PDF, or reopen it to make corrections.',
      attachTo: { element: '[data-tour="rec-history"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-start-btn',
      title: `Start New Reconciliation <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Click here to begin a new reconciliation. You\'ll enter the closing date and balance from your bank statement.',
      attachTo: { element: '[data-tour="rec-start-btn"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-status-card',
      title: `Opening & Closing Balances <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Your opening balance carries forward from your last reconciliation. Enter the closing balance and date from your bank statement — this is the target you\'re trying to match.',
      attachTo: { element: '[data-tour="rec-status-card"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-register',
      title: `Clearing Transactions <span class="t3-shepherd-step-count">${stepCounter(6)}</span>`,
      text: 'Mark each transaction as \'cleared\' if it appears on your bank statement. The status card above updates in real time — when cleared transactions match your closing balance, you\'re balanced!',
      attachTo: { element: '[data-tour="rec-register"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'rec-balance-status',
      title: `Balanced Indicator <span class="t3-shepherd-step-count">${stepCounter(7)}</span>`,
      text: '\'Balanced\' means the total of your cleared transactions matches the closing balance from your bank statement. Once balanced, you can finalize the reconciliation.',
      attachTo: { element: '[data-tour="rec-balance-status"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'reconciliation',
  pathPattern: '/upkeep/reconciliation',
  getSteps,
  label: 'Reconciliation Tour',
});
